// @flow

import * as React from 'react';
import classNames from 'classnames';
import type { MobileImageStyle } from 'type/type';

import './ProgressiveImage.scss';

type Props = {
  src: string,
  thumbnail: string,
  alt?: string,
  aspectRatio: string,
  autoHeight?: boolean,
  mobileImageStyle?: MobileImageStyle,
  designedMobileHeight?: number | null
}

type State = {
  loaded: boolean
}

class ProgressiveImage extends React.Component<Props, State> {
  static defaultProps = {
    alt: '',
    autoHeight: true,
    mobileImageStyle: {},
  }

  mounted: boolean

  constructor(props: Props) {
    super(props);
    this.state = {
      loaded: false,
    };
  }

  componentDidMount() {
    this.mounted = true;
    this.loadImage();
  }

  loadImage() {
    const image = new Image();
    image.onload = () => {
      if (this.mounted) {
        this.setState({ loaded: true });
      }
    };
    image.src = this.props.src;

    return image;
  }

  componentWillUnmount() {
    this.mounted = false;
  }

  render() {
    const {
      src, thumbnail, alt, aspectRatio, autoHeight, mobileImageStyle, designedMobileHeight,
    } = this.props;
    const { loaded } = this.state;
    const mobileImageHeight = designedMobileHeight ? { height: `${designedMobileHeight}px` } : null;

    return (
      <div className="progressive-image" style={mobileImageHeight}>
        { autoHeight
        && <div className="aspect-ratio-placeholder" style={{ paddingBottom: aspectRatio }} /> }
        <div className={classNames('media', { loaded })} style={mobileImageStyle}>
          <img src={thumbnail} alt={alt} className="thumbnail" />
          <img src={loaded ? src : ''} alt={alt} className="image" />
        </div>
      </div>
    );
  }
}

export default ProgressiveImage;
